module.exports = __webpack_public_path__ + "static/img/2_northern_japan.6766e3d3.png";